import { getCurrentInstance } from "vue";

var toastQueue = [];

const toastPermission = (msg) => {
  if (toastQueue.indexOf(msg) >= 0) return false;
  toastQueue.push(msg);
  setTimeout(() => {
    toastQueue.splice(toastQueue.indexOf(msg), 1);
  }, 9000);
  return true;
};

export function useToast() {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error("useToast() debe ser usado dentro de setup()");
  }

  const toast = instance.proxy.$toast;

  return {
    open: toast.open,
    success: (message) =>
      toast.open({ message, type: "success", duration: 4000, position: "top-right" }),
    error: (message) => toast.open({ message, type: "error" }),
    error_right: (message) => toast.open({ message, type: "error", position: "top-right"  }),
    warning: (message) =>
      toast.open({ message, type: "warning", duration: 4000, position: "top-right" }),
    info: (message) => toast.open({ message, type: "info" }),
    toast_open(options) {
      if (toastPermission(options.message)) toast.open(options);
    },
  };
}
